import React, { FC, useContext } from 'react';
import { useSelector } from 'react-redux';
import { NamedLink } from '../../components';
import { ListingPageParamTab } from './EditListingPage.utils';
import { EditListingPageState } from './EditListingPage.duck';
import { ListingItemType } from '../../types/sharetribe/listing';
import { getUrlHash } from '../../util/urlHelpers';
import { ISOContext } from '../../components/ISOModal/ISOModal';
import { useListingFlowConfig } from '../../hooks/useListingFlowConfig';
import TypographyWrapper, {
  TypographyFormat,
} from '../../components/TypographyWrapper/TypographyWrapper';

interface CannotFindItemLinkProps {
  listingItemType?: ListingItemType;
  children?: React.ReactNode;
}

const CannotFindItemLink: FC<CannotFindItemLinkProps> = (props) => {
  const { listingItemType, children } = props;
  const isISO = useContext(ISOContext);
  const { params } = useSelector<any>((state) => state.EditListingPage) as EditListingPageState;
  const search = listingItemType ? new URLSearchParams({ listingItemType }).toString() : null;
  const hash = getUrlHash()?.substring(1);

  const { cannotFindMyItemText } = useListingFlowConfig();

  // TODO: TREET-5498 determine whether this ISO context is still necessary
  if (isISO || !params) {
    return null;
  }

  return (
    <NamedLink
      name="EditListingPage"
      params={{ ...params, tab: ListingPageParamTab.CannotFind }}
      {...{ to: { search, hash } }}
    >
      {children || (
        <TypographyWrapper variant="body2" format={TypographyFormat.Underlined}>
          {cannotFindMyItemText || 'Can’t find your item?'}
        </TypographyWrapper>
      )}
    </NamedLink>
  );
};

export default CannotFindItemLink;
